import React from 'react'

const YoutubeModal4 = () => {
    return (
        <div><div>
            <div className="modal fade custm-yt-modal" data-backdrop="static" id="ytModal4" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
                            <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <iframe className="w-100" height="400" src="https://www.youtube.com/embed/Z3B5UN9t1DA?si=U8c7H6AWMTRTXwhl" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div></div>
    )
}

export default YoutubeModal4